import React from 'react'
import { useAuth } from '../../_helper/Auth/AuthProvider'
import { Student911CollegeProfile } from '../StudentCollegeProfile/Student911CollegeProfile'

// Parent view for a single student's college profile (read-only)
const ParentCollegeProfile = () => {
	const { user } = useAuth()
	const studentId = user?.studentId

	if (!studentId) {
		return (
			<div className="container-fluid">
				<div className="row">
					<div className="col-12">
						<div className="card">
							<div className="card-body">
								<h5 className="card-title mb-3">College Profile</h5>
								<p className="mb-0">No active student is linked to this parent account.</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}

	return <Student911CollegeProfile studentId={studentId} />
}

export { ParentCollegeProfile }


